import React, { Component } from "react";
import { connect } from "react-redux";
import style from "../../assets/css/modules/contact-us/contact-us.css";
import herostyle from "../../assets/css/modules/health-support/health-support.css";
import Content from "../../content/Content";
import contentify from "../../content/Contentify";
import Store from "../../content/Store";
import HomeCard from "../home/HomeCard";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import ShadowedContainerSME from "../shared/containers/ShadowedContainerSME";
import GenericHero from "../shared/GenericHero";
import { EPDomain_ROOT } from "../../constants/EP-config";
import EPQueryParams from "../../constants/EPQueryParams";
import { Urls } from "../../constants/UrlConstants";
import OnlineLinks from "./onlineLinks/OnlineLinks";
import {
  TravelEU,
  TravelWorld,
  EAPEssential,
  EAPPremier
} from "../../constants/SMEModules";
import {
  shouldShowIfAnySMEModulesMatch,
  shouldShowIfAllSMEModulesDontMatch
} from "./../../helpers/SMEModules/smeModuleHelper";
import { travelOrEapModules } from "../../constants/SMEModulesToMatchOn";
import ErrorImage from "../../assets/img/contact-us/Contact-Us-Leaver-Banner_544x238.png";
import Button from "./../shared/buttons/Button";

export const mapStateToContactUs = (state) => {
  let policy =
    state && state.policyReducer && state.policyReducer.selectedPolicy;
  return {
    isSaga: policy && policy.IsSaga,
    isInternational: policy && policy.IsInternational,
    isSMEModular: policy && policy.IsSMEModular,
    IsSME: policy && policy.IsSME,
    IsLargeCorporate: policy && policy.IsLargeCorporate,
    shouldShowTravelSMEContent: shouldShowIfAnySMEModulesMatch(policy, [
      TravelEU,
      TravelWorld
    ]),
    shouldShowEAPContent: shouldShowIfAnySMEModulesMatch(policy, [
      EAPEssential,
      EAPPremier
    ]),
    shouldShowPMIOrTravelOrEapContent: shouldShowIfAllSMEModulesDontMatch(
      policy,
      travelOrEapModules
    ),
    featureFlagEP: state && state.unreadMessagesReducer && state.unreadMessagesReducer.featureFlagEP,
    IsInternalView: state.policyReducer && state.policyReducer.policyDetails && state.policyReducer.policyDetails.IsInternalView,
  };
};

function showPhoneNumberContent(
  phoneNumbers,
  IsSMEModular,
  shouldShowEAPContent,
  shouldShowTravelSMEContent,
  shouldShowForPMIOrTravelOrEapContent
) {
  if (phoneNumbers) {
    if (
      (shouldShowEAPContent || shouldShowTravelSMEContent) &&
      !shouldShowForPMIOrTravelOrEapContent
    ) {
      return phoneNumbers.TravelOrEAP;
    } else if (IsSMEModular || shouldShowForPMIOrTravelOrEapContent) {
      return phoneNumbers.SMEModular;
    }
  }
  return;
}
export class ContactUs extends Component {
  static content = Store.ContactUs;
  constructor(props) {
    super(props);
    this.state = {
      urlAskMedExpert: Urls.EngagementPortal[EPDomain_ROOT].new,
      urlGeneralEnquiry: Urls.EngagementPortal[EPDomain_ROOT].newmessage,
      urlMakeComplaint: Urls.EngagementPortal[EPDomain_ROOT].new,
      urlGPReferralLetter: Urls.EngagementPortal[EPDomain_ROOT].new
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }
  onButtonClick(uri) {
    window.open(uri);
  }
  handleCallbackAskMedExpert = (data) => {
    this.setState({ urlAskMedExpert: data });
  };
  handleCallbackGeneralEnquiry = (data) => {
    this.setState({ urlGeneralEnquiry: data });
  };
  handleCallbackMakeComplaint = (data) => {
    this.setState({ urlMakeComplaint: data });
  };
  handleCallbackGPReferralLetter = (data) => {
    this.setState({ urlGPReferralLetter: data });
  };

  onSubmit() {
    window.open(Urls.RequestCallBack, "_blank", "noreferrer");
  }
  render() {
    let phoneNumberContent = showPhoneNumberContent(
      this.props.content,
      this.props.isSMEModular,
      this.props.shouldShowEAPContent,
      this.props.shouldShowTravelSMEContent,
      this.props.shouldShowPMIOrTravelOrEapContent
    );

    return (
      <React.Fragment>
        <div className={"home " + style.contactus}>
          <GenericHero
            HeroBG={Store.ContactUs.HeroContent.ContactUsBannerSrc}
            HeroBGMobile={Store.ContactUs.HeroContent.ContactUsBannerSrcMobile}
            Heading={Store.ContactUs.HeroContent.Heading}
            DarkOverlay={false}
            ExtraClasses={herostyle.removeBoxPaddingAtBottom}
            backgroundColor="#070E40"
          >
            <h2 className={style.header}>
              <Content name={Store.ContactUs.HeroContent.Header} />
            </h2>
            <Content name={Store.ContactUs.HeroContent.Description} />
            <div className={style.helplinks}>
              <Content name={Store.ContactUs.HeroContent.HowCanWeHelp} />
              <OnlineLinks featureFlagEP={this.props.featureFlagEP}
                urlAskMedExpert={this.state.urlAskMedExpert}
                urlGeneralEnquiry={this.state.urlGeneralEnquiry}
                urlMakeComplaint={this.state.urlMakeComplaint}
                urlGPReferralLetter={this.state.urlGPReferralLetter}
                isDisabled={this.props.IsInternalView}
                disableStyle={this.props.IsInternalView} />
            </div>
            <div className={style.profileInfo}>
              <Content name={Store.ContactUs.HeroContent.ProfileInfo} />
            </div>
          </GenericHero>
        </div>
        <EPQueryParams url={this.state.urlAskMedExpert} messageType="askMedicalQuestion" updatedURL={this.handleCallbackAskMedExpert} />
        <EPQueryParams url={this.state.urlGeneralEnquiry} updatedURL={this.handleCallbackGeneralEnquiry} />
        <EPQueryParams url={this.state.urlMakeComplaint} messageType="makeComplaint" updatedURL={this.handleCallbackMakeComplaint} />
        <EPQueryParams url={this.state.urlGPReferralLetter} messageType="uploadDocument" updatedURL={this.handleCallbackGPReferralLetter} />
        <div className={style.contactusWrapper}>
          <ShadowedContainer>
            <div className={style.contactusBox}>
              <h2>
                <Content name={Store.ContactUs.PhoneHeader} />
              </h2>
              <div className="row mb-3">
                <Content
                  name={
                    phoneNumberContent
                      ? phoneNumberContent
                      : Store.ContactUs.PhoneNumbers
                  }
                >
                  {(numbers) =>
                    numbers.map((number, idx) =>
                      number ? (
                        <div
                          key={idx}
                          className={ numbers.length <= 4 ? "col-lg-3" : "col-lg-4 pb-3"
                            //this.props.isInternational 
                            //||  this.props.isSMEModular
                              //? "col-lg-4"
                              //: "col-lg-3"
                          }
                        >
                          <h3>{number.heading}</h3>
                          {number.phoneNumber ? (
                            <p className={style.phoneNumber}>
                              {number.phoneNumber}
                            </p>
                          ) : null}
                          {number.phoneNumbers
                            ? number.phoneNumbers.map((number2, idx2) => (
                              <React.Fragment key={idx2}>
                                <p className={style.phoneNumber}>
                                  {number2.number}
                                </p>
                                {number2.comment ? (
                                  <p className={style.phoneNumberComment}>
                                    {number2.comment}
                                  </p>
                                ) : null}
                              </React.Fragment>
                            ))
                            : null}
                          <p className={style.phoneNumberComment}>
                            {number.openingHours}
                          </p>
                        </div>
                      ) : null
                    )
                  }
                </Content>
              </div>
              <p className={style.phoneNumberComment}>
                <Content name={Store.ContactUs.PhoneDisclaimer} />
              </p>
            </div>
          </ShadowedContainer>
        </div>

        {this.props.shouldShowTravelSMEContent ? (
          <ShadowedContainer>
            <div className={style.contactusBox}>
              <h2>
                <Content name={Store.ContactUs.travelHeading} />
              </h2>
              <Content name={Store.ContactUs.travelDescription} />
            </div>
          </ShadowedContainer>
        ) : null}

        {this.props.shouldShowEAPContent ? (
          <ShadowedContainer>
            <div className={style.contactusBox}>
              <h2>
                <Content name={Store.ContactUs.eapHeading} />
              </h2>
              <Content name={Store.ContactUs.eapDescription} />
            </div>
          </ShadowedContainer>
        ) : null}

        <div className="container">
          <div className="row">
            <div className={this.props.isSaga ? "col-lg-6" : "col-12"}>
              <Content
                names={[
                  Store.ContactUs.PostHeader,
                  Store.ContactUs.PostAddress
                ]}
              >
                {(header, address) => (
                  <HomeCard
                    Heading={header}
                    Description={address}
                    iclass="icon-functional-inbox"
                  />
                )}
              </Content>
            </div>
            {this.props.isSaga ? (
              <div className="col-lg-6">
                <Content
                  names={[
                    Store.ContactUs.PostHeader2,
                    Store.ContactUs.PostAddress2
                  ]}
                >
                  {(header, address) => (
                    <HomeCard
                      Heading={header}
                      Description={address}
                      iclass="icon-functional-inbox"
                    />
                  )}
                </Content>
              </div>
            ) : null}
          </div>
        </div>
        {this.props.IsLargeCorporate || this.props.IsSME ? (
          <div className="container">
            <div className="row">
              <ShadowedContainerSME>
                <div className={style.contactusBox}>
                  <h2>
                    <Content name={Store.ContactUs.LeaverHeader} />
                  </h2>
                </div>
                <div className={style.contactLayout}>
                <div className={ "row"}> 
                  <div className="col-xl-7">
                    <div>
                      <Content name={Store.ContactUs.LeaverDescription} />
                    </div>
                    <div className={"container " + style.buttonRowSpacing}>
              <div className="row">
                  <div className="col-lg-12 p-0">
                    <div style={{ textAlign: "center" }}>
                      <Button
                        buttonType="secondaryBlueButton"
                        label={Store.ContactUs.CallusOn}
                        contactUs="contactUs"
                        ClassName="icon-phones"                        
                      />
                      <Button
                        buttonType="primaryBlueButton"
                        onClick={this.onSubmit}
                        label={Store.ContactUs.RequestCallBack}
                        contactUs="contactUs"
                        ClassName="icon-contact"
                      />
                    </div>
                  </div>
              </div>
            </div>
                  </div>
                  <div className={"col-md-5 d-none d-sm-block" }>

                    <img className={style.contactImg} src={ErrorImage} alt="" />
                  </div>
                </div>
                </div>
                <div>
                <Content name={Store.ContactUs.LeaverDescription1} />
                </div>
              </ShadowedContainerSME>
            </div>
          </div>
          ) : null}
      </React.Fragment>


    );
  }
}
export default connect(mapStateToContactUs)(contentify(ContactUs));
